
import React from "react";
import { Puzzle } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

const ToolUsageInstructions: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>How to Use Tools</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div>
            <h3 className="font-medium mb-2">Embedding Tools in Blog Posts</h3>
            <ol className="list-decimal pl-5 space-y-2">
              <li>
                Open the post editor for any blog post
              </li>
              <li>
                Place your cursor where you want to insert the tool
              </li>
              <li>
                Click the <Puzzle className="h-4 w-4 inline mx-1" /> tool button in the editor toolbar
              </li>
              <li>
                The tool will be embedded at the cursor position
              </li>
            </ol>
          </div>
          
          <div>
            <h3 className="font-medium mb-2">Configuring Tools</h3>
            <p>
              Each tool can be configured individually to change its appearance and behavior.
              Click the "Configure" button next to any tool to access its settings.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ToolUsageInstructions;
